import type { ColumnDef } from "@tanstack/react-table"

import type { AssociatedTestTemplate, ProductTestResult } from "@/graphql/codegen/graphql"
import { getTestTemplateComparisonLabel } from "@/screens/ManageProducts/components/TestTemplates/utils"
import { formatAssociatedTestTemplateLimits } from "@/screens/Products/components/Product/Quality/TestTemplates/utils"

export const overrideResultsTableColumns: ColumnDef<ProductTestResult>[] = [
  {
    accessorKey: "testId",
    header: "Test #",
    cell: ({ row }) => row.original.associatedTestTemplate?.testTemplate?.externalSystemId ?? "-",
    size: 90,
  },
  {
    accessorKey: "description",
    header: "Description",
    cell: ({ row }) => row.original.associatedTestTemplate?.testTemplate?.description ?? "-",
  },
  {
    accessorKey: "comparison",
    header: "Comparison",
    cell: ({ row }) =>
      getTestTemplateComparisonLabel(row.original.associatedTestTemplate?.testTemplate?.comparison ?? ""),
  },
  {
    accessorKey: "limit",
    header: "Limit",
    cell: ({ row }) =>
      formatAssociatedTestTemplateLimits(row.original.associatedTestTemplate ?? ({} as AssociatedTestTemplate)),
    size: 120,
  },
  {
    accessorKey: "resultsUom",
    header: "Results UoM",
    cell: ({ row }) => row.original.value ?? "-",
  },
]
